/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Hide_UnsupportedInputs */



/**
* | output |
* | --- |
* | "Hide Unsupported" |
*
* @param {Spaces_Hide_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_hide_unsupported = /** @type {((inputs?: Spaces_Hide_UnsupportedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Hide_UnsupportedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht unterstützte ausblenden")
	return /** @type {LocalizedString} */ ("Hide Unsupported")
});